<script>
    import {onMount, onDestroy} from 'svelte';

    const parentWindow = (window.location != window.parent.location) ? document.referrer : document.location.href;
    export let config;

    function setup() {
        if(typeof config.mapping.adUrl !== 'undefined') {
            const a = document.createElement('a');
            const url = new URL(`https://ads.custom-research.de/${config.mapping.adUrl}.html`);
            const urlParams = new URLSearchParams(window.location.search);

            urlParams.set('referrer', parentWindow);

            a.setAttribute('target', '_self');
            a.setAttribute('href', `${url}?${urlParams}`);
            a.click();
        }
    }

    function destroy() {
    }

    onMount(setup);
    onDestroy(destroy);
</script>

<style src="Ad.scss"></style>
